<div class="container-header">
    <div fxLayout="row" fxLayoutAlign="">
        <span class="icon-back" (click)="back()">
            <fa-icon [icon]="faChevronLeft"></fa-icon>
        </span>
        <label class="title-header">Aprobar facturas</label>
        <!--<app-label-chips estado="proceso">Estado SII</app-label-chips>-->
        <app-label-chips [estado]="estiloEstadoSemaforo">{{estadoSemaforo}}</app-label-chips>
    </div>
</div>
<div class="container-body">
    <div class="card-ic container-header-button">
        <app-button [text]="'Rechazar'" [size]="'small'" [type]="'error-outline'"
            (clickAction)="openModalRechazar($event)"></app-button>
        <app-button [text]="'Aprobar'" [size]="'small'" [type]="'success-outline'"
            (clickAction)="openModalAprobar($event)"></app-button>
        <div class="separador-icon">
            <div class="line">
            </div>
        </div>
        <app-icon-action [icon]="faClockRotateLeft" [messageTooltip]="'Historial'" [positionTooltip]="'bottom-right'"
            (clickAction)="openHistory()"></app-icon-action>
    </div>
    <div class="card-ic container-detail-header">
        <cabecera-detalle-factura [detalleFact]="detalleFact">
        </cabecera-detalle-factura>
    </div>
    <div class="content-tab">
        <contenido-documento [listDocAsociados]="listDocAsociados" [detalleFact]="detalleFact"></contenido-documento>
    </div>
    <div class="content-flujo">
        <contenido-flujo (clickEditFlow)="openModalEdit()" [flujoAprobacion]="flujoAprobacion" [dataDetail]="dataDetailFlujo"></contenido-flujo>
    </div>
</div>


<!--Contenido Modal-->

<app-modal [isModalOpen]="modalAprobar" [modalTemplate]="modalTemplateAprobar" [title]="'Aprobar Factura'"
    [nameButtonPrincipal]="'Aprobar'" (clikCloseModal)="clikCloseModal($event)"
    (clikSuccessModal)="clickModalAprobar()">
    <ng-template #modalTemplateAprobar>
        <div class="contenido-modal">
            <div class="contenido-icono-modal aprobar">
                <fa-icon [icon]="faCheckCircle"></fa-icon>
            </div>
            <p>¿Estás seguro que quieres aprobar la <b>Factura </b>?</p>
            <app-input *ngIf="mostrarSelectFormaPago" class="input-custom" fxFlex="50" [tipo]="'select-search'" [label]="'Forma de Pago'" 
                [parentForm]="formulario" placeholder="Seleccionar" [controlName]="'formaPago'" [opciones]="formadePago" [id]="'formaPago'"
                (changeEventSelect)="seleccionarFormaPago($event)" [refresSelectInputSelect]="refresSelectInputSelect">
            </app-input>
            <app-input [parentForm]="formulario" [controlName]="'comentarioAprobar'" [label]="'Comentario'"
                [placeholder]="'Ingresar breve comentario...'" [tipo]="'textarea'" [id]="'ComentarioAprobar'">
            </app-input>
        </div>
    </ng-template>
</app-modal>

<app-modal [isModalOpen]="modalRechazar" [modalTemplate]="modalTemplateRechazar" [title]="'Rechazar Factura'"
    [nameButtonPrincipal]="'Rechazar'" styleButtonPrincipal="error" (clikCloseModal)="clikCloseModal($event)"
    (clikSuccessModal)="clickModalRechazar()">
    <ng-template #modalTemplateRechazar>
        <div class="contenido-modal">
            <div class="contenido-icono-modal rechazar">
                <fa-icon [icon]="faTimesCircle"></fa-icon>
            </div>
            <p>¿Estás seguro que quieres rechazar la <b>Factura </b>?</p>
            <app-input [parentForm]="formulario" [controlName]="'comentarioRechazar'" [label]="'Comentario'"
                [placeholder]="'Ingresar breve comentario...'" [tipo]="'textarea'" [id]="'ComentarioRechazar'">
            </app-input>
        </div>
    </ng-template>
</app-modal>

<app-modal [isModalOpen]="modalHistorial" [modalTemplate]="modalTemplateHistorial" [title]="'Historial'"
    [isFotterAction]="false" (clikCloseModal)="clikCloseModal($event)" [noneSpace]="true" [fullScreen]="true"
    [titleStart]="true">
    <ng-template #modalTemplateHistorial>
        <div class="">
            <app-table id="tableListHistorial" [dataShowItem]="dataListadoHistorial" [dataConfig]="dataConfigHistory">
            </app-table>
        </div>
    </ng-template>
</app-modal>

<app-modal [isModalOpen]="modalEditarFlujo" [modalTemplate]="modalTemplateFlow" [title]="'Editar Flujo de Aprobación'"
    [nameButtonPrincipal]="'Guardar'" (clikCloseModal)="clikCloseModal($event)" (clikSuccessModal)="editarFlujo()"
    [modalConfirm]="false">
    <ng-template #modalTemplateFlow>
        <div fxLayout="row wrap" class="contenido-modal-editar">
            <label fxFlex="100">
                Nuevo Aprobador
            </label>
            <app-input class="input-custom" fxFlex="50" [tipo]="'select-search'" [label]="'Nombre aprobador'" [parentForm]="formularioEditar"
                placeholder="Seleccionar" [controlName]="'aprobador'" [opciones]="aprobadores" [id]="'aprobador'"
                (changeEventSelect)="seleccionarAprobador($event)">
            </app-input>
            <form [formGroup]="formularioEditar" fxFlex="25" class="content-radio-bottom">
                <div *ngFor="let opcion of opciones; let i = index" class="radio-button-group">
                    <input type="radio" [formControlName]="'opcionSeleccionada'" [value]="opcion.value"
                        [id]="'opcion-' + i" />
                    <label [for]="'opcion-' + i" class="radio-label">{{ opcion.label }}</label>
                </div>
                <div class="contenido-error-radio"
                    *ngIf="formularioEditar.get('opcionSeleccionada')?.errors?.['required'] && formularioEditar.get('opcionSeleccionada')?.touched">
                    <div class="contenedor-error">
                        <span class="error-text">Este campo es obligatorio.</span>
                    </div>
                </div>
            </form>
            <app-input fxFlex="100" [parentForm]="formularioEditar" [controlName]="'comentarioEditar'"
                [label]="'Comentario'" [placeholder]="'Ingresa un breve comentario...'" [tipo]="'textarea'"
                [id]="'comentarioEditar'">
            </app-input>
        </div>
    </ng-template>
</app-modal>

<app-snack-bar class="positionSnackbar" [showSnackBar]="showSnackBar" [type]="typeSnackBar"
      [tituloSnackBar]="tituloSnackBar" [mensajeSnackBar]="mensajeSnackBar"
      (closeSnackBar)="closeSnackBar($event)">
</app-snack-bar>